import { Navigate, useParams } from "react-router-dom";
import CashbackProgram from "../CashbackProgram";
import { PATH_PROGRAM, halamanDariSlug } from "./halamanPP";

// Rute halaman menu 3 tingkat (brief owner 22 Sep 2026 hal. 1–2):
// `/finance/cashback/programs/:jenis/:kanal` → SATU komponen halaman
// (`CashbackProgram`) dengan halaman yang ditetapkan rute, jadi pemilih halaman
// di dalamnya disembunyikan. Slug dibaca dari peta yang SAMA dengan menu
// (`halamanPP.js::HALAMAN_PP`) — menu dan rute tidak bisa berpisah jalan.
//
// Slug asing (tautan salah ketik / halaman yang kelak dihapus) diarahkan ke
// rute lama "Semua Program", bukan halaman kosong. `key` per halaman: pindah
// dari Aktivasi ke Cashback lewat menu memulai halaman dari awal (tab, filter,
// modal terbuka), bukan membawa keadaan halaman sebelumnya.
export default function HalamanPPRute() {
  const { jenis, kanal } = useParams();
  const halaman = halamanDariSlug(jenis, kanal);
  if (!halaman) return <Navigate to={PATH_PROGRAM} replace />;
  return <CashbackProgram key={halaman.kunci} halamanTetap={halaman.kunci} />;
}
